import { createFormHook } from '@tanstack/react-form';
import {
  fieldContext,
  formContext,
} from './proposal-decision-form-context.hook';
import { ProposalAnalysisFormFields } from './form-fields';

const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField: ProposalAnalysisFormFields.TextField,
    TextareaField: ProposalAnalysisFormFields.TextareaField,
    NumberField: ProposalAnalysisFormFields.NumberField,
    DateField: ProposalAnalysisFormFields.DateField,
    CheckboxField: ProposalAnalysisFormFields.CheckboxField,
    SelectField: ProposalAnalysisFormFields.SelectField,
    RadioButtonGroup: ProposalAnalysisFormFields.RadioButtonGroup,
    UploadField: ProposalAnalysisFormFields.UploadField,
    RadioCardField: ProposalAnalysisFormFields.RadioCardField,
    CalendarField: ProposalAnalysisFormFields.CalendarField,
  },
  formComponents: {},
});

export { useAppForm as useProposalDecisionForm, withForm };
